import React from "react";
import classNames from "classnames";

import { _t } from "../../../languageHandler";
import { getUserNameColorClass } from "../../../utils/FormattingUtils";
// import UserIdentifier from "../../../customisations/UserIdentifier";
import { ContactStateManager } from "../../../customisations/ContactStateManager";

interface MemberInfo {
    userId: string;
    roomId: string;
    rawDisplayName?: string;
    disambiguate: boolean;
}

interface IProps {
    member?: MemberInfo | null;
    fallbackName: string;
    onClick?(): void;
    colored?: boolean;
    emphasizeDisplayName?: boolean;
    withTooltip?: boolean;
}

export default class DisambiguatedProfile extends React.PureComponent<IProps> {
    public render(): React.ReactNode {
        const { fallbackName, member, colored, emphasizeDisplayName, withTooltip, onClick } = this.props;
        const rawDisplayName = member?.rawDisplayName || fallbackName;
        const mxid = member?.userId;

        const contact = mxid ? ContactStateManager.getContactByMatrixName(mxid) : undefined;
        const displayName = contact
            ? ContactStateManager.getContactsNameFormat([contact], null)
            : rawDisplayName;

        let colorClass: string | undefined;
        if (colored) {
            colorClass = getUserNameColorClass(mxid ?? "");
        }

        let mxidElement;
        let title: string | undefined;

        if (mxid) {
            const identifier = ContactStateManager.getContactEmailByMatrixName(mxid, true) ?? mxid;
            // const identifier =
            //     UserIdentifier.getDisplayUserIdentifier?.(mxid, {
            //         roomId: member.roomId,
            //         withDisplayName: true,
            //         withEmail: true
            //     }) ?? mxid;
            if (member?.disambiguate) {
                mxidElement = <span className="mx_DisambiguatedProfile_mxid">{identifier}</span>;
            }
            title = _t("timeline.disambiguated_profile", {
                displayName: displayName,
                matrixId: identifier,
            });
        }

        const displayNameClasses = classNames(colorClass, {
            mx_DisambiguatedProfile_displayName: emphasizeDisplayName,
        });

        return (
            <div className="mx_DisambiguatedProfile" title={withTooltip ? title : undefined} onClick={onClick}>
                <span className={displayNameClasses} dir="auto">
                    {displayName}
                </span>
                {mxidElement}
            </div>
        );
    }
}
